module.exports = "/_next/static/images/step_3-de939df71571fd91dda5fe9d2cfd3727.png";